// extracted by mini-css-extract-plugin
export var textInput = "_kh-0";